export const EmptyTemplateWithRouterView = (alwaysReload: boolean = false): string =>
  alwaysReload
    ? '<router-view :key="this.$route.fullPath"></router-view>'
    : '<router-view></router-view>';
